import defaultSettings from '@/settings';
import { useSettingsStore } from '@/store/modules/settings';
import useUserStore from '@/store/modules/user';

/**
 * 动态修改标题：优先使用租户自定义系统名称，其次动态标题配置，最后默认标题
 */
export const useDynamicTitle = () => {
  const settingsStore = useSettingsStore();
  const userStore = useUserStore();
  const systemName = userStore.systemInfo?.name;
  if (systemName) {
    document.title = systemName;
    return;
  }
  if (settingsStore.dynamicTitle) {
    document.title = settingsStore.title + ' - ' + import.meta.env.VITE_APP_TITLE;
  } else {
    document.title = defaultSettings.title as string;
  }
};
